var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.getPhoneLink(_vm.phoneNumber),"title":_vm.getTitle(_vm.phoneNumber)}},[_vm._v(_vm._s(_vm.phoneNumber))])
}
var staticRenderFns = []

export { render, staticRenderFns }